{
    "customer_detail__no_tasks": "There are no tasks here yet",
    "customer_detail__no_tasks_description": "Use tasks to delegate things or set yourself a reminder",
    "customer_detail__add_task": "Create new task",
    "customer_detail__no_open_tasks": "There are no tasks here yet",
    "customer_detail__no_open_tasks_description": "Use tasks to delegate things or set yourself a reminder",
    "customer_detail__no_completed_tasks": "There are no tasks here yet",
    "customer_detail__no_completed_tasks_description": "There are currently no completed tasks for this customer",
    "customer_detail__no_notes": "No interactions",
    "customer_detail__no_notes_description": "Use interactions to record information about this customer for all to see",
    "customer_detail__add_note": "Log interaction",
    "status_change__status_active": "Active",
    "status_change__status_inactive": "Inactive",
    "status_change__marked_inactive": "<strong>Marked as permanently inactive</strong> by {{user}}",
    "status_change__reactivated": "<strong>Marked as active</strong> by {{user}}",
    "log__status_inactive": "Marked as permanently inactive",
    "log__status_active": "Marked as active",
    "log__insight_interested": "{{insightType}} “{{entity}}” marked as relevant",
    "log__insight_no_need": "{{insightType}} “{{entity}}” marked as no need",
    "log__insight_buys_elsewhere": "{{insightType}} “{{entity}}” marked as buys elsewhere",
    "log__insight_not_relevant": "{{insightType}} “{{entity}}” marked as not relevant",
    "log__insight_value": "Revenue potential {{value}}",
    "search_placeholder__customer": "Search by article, order, quote …",
    "search_placeholder__global": "Search by customer, note, task",
    "filter__title": "Filter",
    "filter__add": "Filter",
    "filter__apply": "Apply",
    "filter__clear_all": "Clear all",
    "filter__close": "Close",
    "filter__back": "Back",
    "filter__remove": "Remove {{filter}} filter",
    "filter__category_type": "Type",
    "search__clear": "Clear search",
    "presets__label": "Quick filters",
    "day__no_due_date": "No due date",
    "feed__empty": "No activities",
    "feed__pinned": "Pinned",
    "card__positions_load_error": "Couldn’t load items",
    "card__open": "Open {{name}}",
    "card__attachments_one": "{{count}} attachment",
    "card__attachments_other": "{{count}} attachments",
    "card__quote_title": "Quote: #{{id}}",
    "card__order_title": "Order: #{{id}}"
}
